import type { ReactNode } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import styles from './BackLink.module.css';

interface BackLinkProps {
  children: ReactNode;
  /** Обычная ссылка; без неё — кнопка с `onClick` (когда назад нужно вернуться по истории). */
  to?: string;
  onClick?: () => void;
}

/** «← Сметы» и похожие: один вид возврата на всех экранах раздела. */
export function BackLink({ children, to, onClick }: BackLinkProps) {
  const content = (
    <>
      <ArrowLeftOutlined aria-hidden />
      {children}
    </>
  );
  if (to) return <Link to={to} className={styles.back}>{content}</Link>;
  return <button type="button" className={styles.back} onClick={onClick}>{content}</button>;
}
